<template>
  <div class="border_1 border_light_teal h-100 w-100 p-3">
    <div class="survey-results__menus_wrapper">
      <v-wait :visible="loading" :for="$options.name">
        <template slot="waiting">
          <HalfCircleSpinner/>
          <div class="spinner-message my-3 text-center">
            Checking criteria data...
          </div>
        </template>
        <template>
          <div
              class="font_size_1125rem font-weight-bold v3_color_teal my-0 border_bottom_1 border_bottom_light_teal"
          >
            <span>
              Job Criteria
            </span>
          </div>

          <template v-if="this.$store.state.user && !isChangeJobCriteriaEnable">
            <div class="d-flex flex-column justify-content-stretch">
              <b-button class="mt-4 btn-disable-btn" :disabled="isChangeJobCriteriaEnable"
                        @click="emitChangeCriteriaBtn">
                Change Your Job Criteria
              </b-button>
            </div>
          </template>

          <slot :items="criteriaItems" :getLabel="getLabel"/>
        </template>
      </v-wait>
    </div>
  </div>
</template>

<script>
import {HalfCircleSpinner} from 'epic-spinners';

export default {
  name: 'RecruiterIcoCriteria',
  components: {
    HalfCircleSpinner,
  },
  props: {
    criteriaItems: {
      type: Array,
      default: function () {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedItemId: {
      validator: (prop) => typeof prop === 'string' || prop === null,
      default: null,
    },
    isChangeJobCriteriaEnable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      criteria: false,
      isChangeCriteria: false, // Flag to control computed property
    };
  },
  methods: {
    getLabel: function (item) {
      return item.talent_label || item.label;
    },
    emitChangeCriteriaBtn() {
      this.$store.state.is_change_criteria = 1;
      // Emit a custom event to the parent with a message
      this.$emit('changeCriteriaBtn');
      this.isChangeCriteria = true;
    }
  },
};
</script>

<style scoped>
.btn-disable-btn {
  display: inline-block;
  max-height: 35px;
}
.btn-disable-btn:disabled {
  display: inline-block;
  max-height: 35px;
}

</style>
